import React, { useEffect } from 'react';
import { Modal, Form, Input, Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { getConfig } from '../../../../config';
import { productBrandService } from '../../../../services/settings-services';
import { productBrandsActions } from '../../../../store/slices/settings-slices';

const ProductBrandsUpdateModal = ({ isOpen, setIsOpen, productBrand }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const { cityCode } = getConfig();

  useEffect(() => {
    if (productBrand && productBrand.name) {
      form.setFieldsValue({
        en: productBrand.name.en || '',
        ru: productBrand.name.ru || '',
        ge: productBrand.name.ge || '',
        ar: productBrand.name.ar || '',
      });
    }
  }, [productBrand, form]);

  const handleSubmit = async (values) => {
    try {
      await productBrandService.updateById(productBrand.id, { name: values });
      dispatch(productBrandsActions.changeTrigger());
      toast.success(t('Brand updated successfully'));
      setIsOpen(false);
      form.resetFields();
    } catch (error) {
      console.error('Error updating brand:', error);
      toast.error(t('Error updating brand'));
    }
  };

  const handleCancel = () => {
    setIsOpen(false);
    form.resetFields();
  };

  return (
    <Modal
      title={t('Update Product Brand')}
      open={isOpen}
      onCancel={handleCancel}
      footer={null}
      width={600}
      destroyOnClose
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        autoComplete="off"
        data-lpignore="true"
        data-form-type="other"
      >
        <Form.Item
          label={`${t('Brand Name')} (English)`}
          name="en"
          rules={[
            {
              required: true,
              message: t('This field is required / Это поле обязательно / ეს ველი აუცილებელია'),
            },
          ]}
        >
          <Input placeholder={t('Enter brand name in English')} />
        </Form.Item>

        <Form.Item
          label={`${t('Brand Name')} (Русский)`}
          name="ru"
          rules={[
            {
              required: true,
              message: t('This field is required / Это поле обязательно / ეს ველი აუცილებელია'),
            },
          ]}
        >
          <Input placeholder={t('Enter brand name in Russian')} />
        </Form.Item>

        {cityCode === 'UAE' ? (
          <Form.Item
            label={`${t('Brand Name')} (العربية)`}
            name="ar"
            rules={[
              {
                required: true,
                message: t('This field is required / Это поле обязательно / ეს ველი აუცილებელია'),
              },
            ]}
          >
            <Input placeholder={t('Enter brand name in Arabic')} />
          </Form.Item>
        ) : (
          <Form.Item
            label={`${t('Brand Name')} (ქართული)`}
            name="ge"
            rules={[
              {
                required: true,
                message: t('This field is required / Esto поле обязательно / ეს ველი აუცილებელია'),
              },
            ]}
          >
            <Input placeholder={t('Enter brand name in Georgian')} />
          </Form.Item>
        )}

        <Form.Item style={{ marginBottom: 0, marginTop: '1.5rem' }}>
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.5rem' }}>
            <Button onClick={handleCancel}>
              {t('Cancel')}
            </Button>
            <Button type="primary" htmlType="submit">
              {t('Update')}
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export { ProductBrandsUpdateModal };
